import { expected } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from './orderSelectors.ts';
import { selectManualAdjustmentsEntities } from './propertyDataSelectors/manualAdjustmentsSelectors.ts';

export const selectManualAdjustmentsForMarketAdjustmentsModalForm = createSelector(
  [selectCompSequence, selectManualAdjustmentsEntities],
  (compSequence, manualAdjustments) => {
    return Object.fromEntries(
      compSequence.map((id) => {
        return [id, expected(manualAdjustments[id])];
      }),
    );
  },
);
